<template>
    <span
        @click.prevent="addModelToFavouritesAndOpenModal(id)"
        class="button favourite"
    >
        <svg
            :class="{
                'added-to-favourites': idArray.includes(id),
            }"
            class="heart mr-2"
            width="28"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 26.5"
            enable-background="new 0 0 30 26.5"
            xml:space="preserve"
        >
            <path
                :class="{
                    'bg stroke': !idArray.includes(id),
                }"
                stroke-width="2"
                d="M26.3,2.7c-3-2.6-7.5-2.1-10.2,0.7L15,4.5l-1.1-1.1
                            C11.2,0.6,6.7,0.1,3.7,2.7c-3.4,2.9-3.6,8.2-0.5,11.4L13.8,25c0.7,0.7,1.8,0.7,2.5,0l10.6-10.9C29.9,10.9,29.7,5.6,26.3,2.7
                            L26.3,2.7z"
            />
        </svg>

        <p v-if="idArray.includes(id)">Added to favourites!</p>
        <p v-else>Favourite</p>
    </span>
    <Favouritesmodal
        v-show="isModalOpen"
        @closeModal="isModalOpen = false"
        :title="title"
        :image="image"
    ></Favouritesmodal>
</template>

<script>
import { ref, toRefs } from "vue";
import FavouritesState, { addModelToFavourites } from "./favourites/State";
import Favouritesmodal from "./Favouritesmodal.vue";

export default {
    props: {
        id: Number,
        title: String,
        image: String,
    },
    setup(props) {
        const { idArray } = toRefs(FavouritesState);
        const isModalOpen = ref(false);

        function addModelToFavouritesAndOpenModal(id) {
            if (!idArray.value.includes(id)) {
                isModalOpen.value = true;
            }
            addModelToFavourites(id);
        }
        return {
            addModelToFavouritesAndOpenModal,
            addModelToFavourites,
            idArray,
            isModalOpen,
        };
    },
    components: { Favouritesmodal },
};
</script>
